import { useMediaQuery, useTheme } from '@mui/material';

/**
 * True below 600 px (the theme's `sm`): the outcome list is cards there, the
 * desktop table from 600 px up. Read on the first render (noSsr), so a phone
 * never draws the table for a frame.
 */
export function useOutcomesOnPhone(): boolean {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
}
